<ui-grid [data]="data$ | async"
         [selectable]="false"
         [loading]="loading$ | async"
         class="ui-robot-license-grid">
    <ui-grid-header [search]="true">
        <ui-header-button type="inline">
            <ng-template>
                <ui-grid-reset *ngIf="hasCustomFilters$ | async"
                               (reset)="resetFilter()"></ui-grid-reset>
            </ng-template>
        </ui-header-button>
    </ui-grid-header>
    <ui-grid-column [primary]="true"
                    [searchable]="true"
                    [title]="'license_runtime_grid_machine' | translate"
                    [sortable]="true"
                    property="machineName"
                    width="30%">
    </ui-grid-column>
    <ui-grid-column [title]="'license_runtime_grid_runtimes' | translate"
                    width="13%"
                    property="runtimes">
    </ui-grid-column>
    <ui-grid-column [title]="'license_runtime_grid_robots' | translate"
                    width="13%"
                    property="robotsCount">
    </ui-grid-column>
    <ui-grid-column [title]="'license_runtime_grid_running' | translate"
                    width="13%"
                    property="executingCount">
    </ui-grid-column>
    <ui-grid-column [title]="'license_runtime_grid_licensed' | translate"
                    width="13%"
                    property="isLicensed"
                    sort="desc">
        <ng-template let-entry="data">
            <ng-container *ngIf="entry.isLicensed">
                <mat-icon *ngIf="entry.executingCount === 0; else usingMoreLicenses"
                          [matTooltip]="'LicensedStatus_Green' | translate"
                          class="entry-status entry-status-active">fiber_manual_record</mat-icon>
                <ng-template #usingMoreLicenses>
                    <mat-icon [matTooltip]="'LicensedStatus_Green_And_Using' | translate: { licensesNumber: entry.executingCount }"
                              class="entry-status entry-status-active">fiber_manual_record</mat-icon>
                </ng-template>
            </ng-container>
            <mat-icon *ngIf="!entry.isLicensed"
                      [matTooltip]="'LicensedStatus_Red' | translate"
                      class="entry-status entry-status-inactive">fiber_manual_record</mat-icon>
        </ng-template>
        <ui-grid-dropdown-filter [items]="licensedFilterList"></ui-grid-dropdown-filter>
    </ui-grid-column>
    <ui-grid-column [primary]="true"
                    [title]="'license_runtime_grid_enabled' | translate"
                    property="enabled"
                    width="18%">
        <ng-template let-entry="data">
            <mat-slide-toggle #toggle
                              [checked]="entry.enabled"
                              [disabled]="!(isMachinesEditGranted$ | async)"
                              (change)="handleMachineToggle(entry, toggle)">
            </mat-slide-toggle>
        </ng-template>
    </ui-grid-column>
    <ui-grid-row-action>
        <ng-template let-entry="data">
            <button [matMenuTriggerFor]="menu"
                    [matTooltip]="'global_more_actions_tooltip' | translate"
                    data-cy="grid-action-menu"
                    mat-icon-button
                    type="button">
                <mat-icon svgIcon="uipath:More"></mat-icon>
            </button>
            <mat-menu #menu="matMenu">
                <button [uiAuthorizeDisable]="'Machines.Edit'"
                        [uiClickTrack]="'Action: Grid: Edit Runtimes'"
                        (click)="editRuntime(entry)"
                        mat-menu-item
                        type="button">
                    <mat-icon>edit</mat-icon>
                    <span>{{ 'license_runtime_grid_action_edit_runtimes' | translate }}</span>
                </button>
                <button [uiAuthorizeAnyDisable]="['Robots.View', 'Users.View']"
                        [routerLink]="['/user-activity']"
                        [queryParams]="encodeFilters({
                            'machineId': {
                                id: entry.machineId,
                                text: entry.machineName
                            },
                            'robot.type': getRobotType(licenseType)
                        })"
                        [uiClickTrack]="'Action: Grid: View Robots'"
                        mat-menu-item>
                    <mat-icon svgIcon="uipath:ViewLogs"></mat-icon>
                    <span>{{ 'license_runtime_grid_action_view_robots' | translate }}</span>
                </button>
            </mat-menu>
        </ng-template>
    </ui-grid-row-action>
    <ui-grid-footer [length]="total$ | async"
                    [pageSize]="pageSize"
                    [pageSizes]="pageSizes">
    </ui-grid-footer>
</ui-grid>
